// extracted by mini-css-extract-plugin
module.exports = {"memberCardContainer":"CommitteeMemberCard_memberCardContainer__3MZ15"};